import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'appkit-react';

const appTitle = process.env.REACT_APP_TITLE;
const privacyPolicyMsg = `${appTitle} Privacy Policy Coming Soon...`;
const PrivacyPolicy = ({ setPrivacyModal }) => (
    <>
        <Modal
            className="baseline-modal-showcase"
            visible
            onCancel={() => setPrivacyModal(false)}
        >
            <ModalHeader>
                <div className="modal-title">Privacy policy</div>
            </ModalHeader>
            <ModalBody>
                <p>{privacyPolicyMsg}</p>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'flex-end' }}>
                <Button kind="transparent" onClick={() => setPrivacyModal(false)}> OK </Button>
            </ModalFooter>
        </Modal>
    </>
);

export default PrivacyPolicy;
